var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-layout"},[_c('app-header'),_c('div',{staticClass:"layout-main"},[_c('div',{staticClass:"p-grid"},[_c('div',{staticClass:"p-col-12"},[_c('div',{staticClass:"card"},[_c('router-view')],1)])])]),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }